<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="stay">待审批</el-menu-item>
          <el-menu-item index="has">已审批</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <List :pageType="activeIndex"></List>
      </div>
    </div>
  </div>
</template>

<script>
import List from './component/list.vue';
export default {
  data() {
    return {
      activeIndex: "stay",
    };
  },
  created() {

  },
  components: {
    List
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
  },
};
</script>